import { render, staticRenderFns } from "./YoneticiListesi.vue?vue&type=template&id=c0387fb4&scoped=true&"
import script from "./YoneticiListesi.vue?vue&type=script&lang=js&"
export * from "./YoneticiListesi.vue?vue&type=script&lang=js&"
import style0 from "./YoneticiListesi.vue?vue&type=style&index=0&id=c0387fb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0387fb4",
  null
  
)

export default component.exports